import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { BrandsEnum, ImageRatioEnum, SdBannerComponent, SdLibConfig, SdPriceComponent, SdTitleComponent } from '@seb/web-design-system/core';

import type { IProductBundle } from './product-bundle.interface';

@Component({
  selector: 'sd-product-bundle',
  templateUrl: './product-bundle.component.html',
  styleUrls: ['./product-bundle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdTitleComponent,
    SdPriceComponent,
    RouterLink,
    SdBannerComponent,
    TranslateModule
  ]
})
export class SdProductBundleComponent implements OnChanges {
  @Input()
  brand: BrandsEnum;

  @Input()
  isTitleAriaHidden = false;

  @Input()
  productInfo: IProductBundle;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel = 4;

  @Output()
  openRecommendedPriceModal = new EventEmitter<void>();

  imageRatio!: ImageRatioEnum;

  constructor(private sdLibConfig: SdLibConfig) {}

  onopenRecommendedPriceModal() {
    this.openRecommendedPriceModal.emit();
  }

  ngOnChanges() {
    this.imageRatio = this.sdLibConfig.get(this.brand).productImageRatio;
  }
}
